/**
 * Playful checked-state glyphs for checkboxes & radios.
 *
 * The variable font ships three hand-drawn "checked" variants per control as
 * Private-Use-Area glyphs (checkbox U+E001–E003, radio U+E011–E013). Each control
 * rolls its own variant when it's toggled on, written as a custom property scoped
 * to that control's own wrapper. The CSS reads it via `content: var(--glyph-…)`,
 * and because the property only lives on that wrapper it inherits down to this
 * control's `label::before` alone — so every checked control can show a different
 * mark, and toggling one never disturbs the others.
 */
const CHECKBOX_GLYPHS = [0xe001, 0xe002, 0xe003]
const RADIO_GLYPHS = [0xe011, 0xe012, 0xe013]

// CSS `content` needs a quoted string; keep the raw PUA chars out of the source.
const pick = (glyphs) =>
  `"${String.fromCharCode(glyphs[Math.floor(Math.random() * glyphs.length)])}"`

const isToggle = (el) =>
  el instanceof HTMLInputElement && (el.type === 'checkbox' || el.type === 'radio')

// Roll one control a fresh variant, scoped to its wrapper (the shared parent of the
// input and its `label`) so the value reaches only this control's `label::before`.
const rollGlyph = (input) => {
  const [prop, glyphs] =
    input.type === 'radio' ? ['--glyph-radio', RADIO_GLYPHS] : ['--glyph-checkbox', CHECKBOX_GLYPHS]
    //input.type === 'radio' ? ['--glyph-radio', RADIO_GLYPHS] : ['--glyph-radio', RADIO_GLYPHS]
  input.parentElement?.style.setProperty(prop, pick(glyphs))
}

// Seed the controls already checked on load (view radio, URL-restored tags), then
// re-roll a single control each time it's toggled.
document.querySelectorAll('input:checked').forEach((input) => {
  if (isToggle(input)) rollGlyph(input)
})

// Static, non-interactive ticks (the checklists on a project detail) opt in via
// data-glyph-checked. They carry no input, so the property goes on the element itself and
// inherits into its own ::before.
document.querySelectorAll('[data-glyph-checked]').forEach((el) => {
  el.style.setProperty('--glyph-checkbox', pick(CHECKBOX_GLYPHS))
})

document.addEventListener('change', ({ target }) => {
  if (isToggle(target)) rollGlyph(target)
})
